import React from 'react';
import "./index.scss"
import MainComponent from '../../../../dashboard/components/mainpage/lend/components/mainComponent/MainComponent';
import FlowList from '../../../../dashboard/components/mainpage/lend/components/flowList/FlowList';
// import Filter from "../../generic/filter/Filter";

const Lend = () => {

  return (
    <div className='lend'>
      {/* <section className='lend__filter'>
        <Filter />
      </section> */}
      <section className='lend__charts'>
        <div className='lend__charts__wrapper'>
          <div className='lend__charts__wrapper__loanTypes'>
            <FlowList />
          </div>
          <div className='lend__charts__wrapper__main'>
            <MainComponent />
          </div>
        </div>
      </section>
    </div>
  )
}

export default Lend;